import { defineMessages } from 'react-intl';

/** The texts of "Where it plays" (SoundCloud connector design d). */
export const servicesPanelMessages = defineMessages({
  title: { id: 'app.sml.servicesPanel.title', defaultMessage: 'Where it plays' },
  subtitle: {
    id: 'app.sml.servicesPanel.subtitle',
    defaultMessage: 'The services fans can open from your SmartLink',
  },
  count: { id: 'app.sml.servicesPanel.count', defaultMessage: '{linked} of {total} linked' },
  countShort: { id: 'app.sml.servicesPanel.countShort', defaultMessage: '{linked} of {total}' },
  unreleasedLead: {
    id: 'app.sml.servicesPanel.unreleasedLead',
    defaultMessage:
      '{title} is out on {date}. On that day MUSIC24 finds it on the services and fills the links. You can add a link now.',
  },
  unreleasedLeadNoDate: {
    id: 'app.sml.servicesPanel.unreleasedLeadNoDate',
    defaultMessage: 'On release day MUSIC24 finds {title} on the services and fills the links. You can add a link now.',
  },
  more: { id: 'app.sml.servicesPanel.more', defaultMessage: 'Show {count} more services' },
  fewer: { id: 'app.sml.servicesPanel.fewer', defaultMessage: 'Show fewer services' },
  notLinked: { id: 'app.sml.servicesPanel.notLinked', defaultMessage: 'Not linked' },
  saving: { id: 'app.sml.servicesPanel.saving', defaultMessage: 'Saving…' },
  // Row actions (d3)
  open: { id: 'app.sml.servicesPanel.action.open', defaultMessage: 'Open' },
  edit: { id: 'app.sml.servicesPanel.action.edit', defaultMessage: 'Edit' },
  paste: { id: 'app.sml.servicesPanel.action.paste', defaultMessage: 'Paste link' },
  findIt: { id: 'app.sml.servicesPanel.action.findIt', defaultMessage: 'Find it' },
  upload: { id: 'app.sml.servicesPanel.action.upload', defaultMessage: 'Upload' },
  connect: { id: 'app.sml.servicesPanel.action.connect', defaultMessage: 'Connect SoundCloud' },
  reconnect: { id: 'app.sml.servicesPanel.action.reconnect', defaultMessage: 'Reconnect SoundCloud' },
  status: { id: 'app.sml.servicesPanel.action.status', defaultMessage: 'Status' },
  cancel: { id: 'app.sml.servicesPanel.action.cancel', defaultMessage: 'Cancel' },
  retry: { id: 'app.sml.servicesPanel.action.retry', defaultMessage: 'Try again' },
  // Chips (d3)
  chipLinked: { id: 'app.sml.servicesPanel.chip.linked', defaultMessage: 'Linked' },
  chipGoesUp: { id: 'app.sml.servicesPanel.chip.goesUp', defaultMessage: 'Goes up {date}' },
  chipUploading: { id: 'app.sml.servicesPanel.chip.uploading', defaultMessage: 'Uploading' },
  chipUploaded: { id: 'app.sml.servicesPanel.chip.uploaded', defaultMessage: 'Uploaded by MUSIC24' },
  chipPrivate: { id: 'app.sml.servicesPanel.chip.private', defaultMessage: 'Private' },
  chipFailed: { id: 'app.sml.servicesPanel.chip.failed', defaultMessage: 'Upload failed' },
  chipSignedOut: { id: 'app.sml.servicesPanel.chip.signedOut', defaultMessage: 'Signed out' },
  chipRemoved: { id: 'app.sml.servicesPanel.chip.removed', defaultMessage: 'Removed' },
  // Upload lines (d3)
  lineWaits: { id: 'app.sml.servicesPanel.line.waits', defaultMessage: 'MUSIC24 uploads it on {date} at {time}' },
  lineUploading: { id: 'app.sml.servicesPanel.line.uploading', defaultMessage: 'Uploading to SoundCloud' },
  lineFailed: { id: 'app.sml.servicesPanel.line.failed', defaultMessage: 'The upload did not finish.' },
  lineSignedOut: {
    id: 'app.sml.servicesPanel.line.signedOut',
    defaultMessage: 'The login stopped working. Reconnect SoundCloud, then try again.',
  },
  lineRemoved: { id: 'app.sml.servicesPanel.line.removed', defaultMessage: 'SoundCloud no longer has this track.' },
  // Paste or edit (d5)
  pastePlaceholder: { id: 'app.sml.servicesPanel.paste.placeholder', defaultMessage: 'Paste the {service} link' },
  pasteHint: {
    id: 'app.sml.servicesPanel.paste.hint',
    defaultMessage: 'The link of the song on {service}.',
  },
  pasteOtherService: {
    id: 'app.sml.servicesPanel.paste.otherService',
    defaultMessage: 'This is a {other} link. Paste the {service} link of the song.',
  },
  pasteOtherServiceUnknown: {
    id: 'app.sml.servicesPanel.paste.otherServiceUnknown',
    defaultMessage: 'This is not a {service} link. Paste the {service} link of the song.',
  },
  pasteAlbum: {
    id: 'app.sml.servicesPanel.paste.album',
    defaultMessage: 'Paste the link of the song, not of the album page.',
  },
  save: { id: 'app.sml.servicesPanel.paste.save', defaultMessage: 'Save' },
  cancelEdit: { id: 'app.sml.servicesPanel.paste.cancel', defaultMessage: 'Cancel' },
  remove: { id: 'app.sml.servicesPanel.paste.remove', defaultMessage: 'Remove the link' },
  saveFailed: { id: 'app.sml.servicesPanel.saveFailed', defaultMessage: 'That did not work. Try again.' },
  cancelUploadTitle: { id: 'app.sml.servicesPanel.cancelUpload.title', defaultMessage: 'Cancel the upload?' },
  cancelUploadBody: {
    id: 'app.sml.servicesPanel.cancelUpload.body',
    defaultMessage: 'MUSIC24 does not upload {title} to SoundCloud. Nothing is on SoundCloud yet.',
  },
  cancelUploadConfirm: { id: 'app.sml.servicesPanel.cancelUpload.confirm', defaultMessage: 'Cancel the upload' },
  cancelUploadKeep: { id: 'app.sml.servicesPanel.cancelUpload.keep', defaultMessage: 'Keep it' },
});

/** The texts of the "Find it" sheet (design d4). */
export const findItMessages = defineMessages({
  title: { id: 'app.sml.servicesPanel.findIt.title', defaultMessage: 'Find {title} on {service}' },
  subtitle: {
    id: 'app.sml.servicesPanel.findIt.subtitle',
    defaultMessage: 'Pick the song. MUSIC24 saves its {service} link.',
  },
  searchLabel: { id: 'app.sml.servicesPanel.findIt.searchLabel', defaultMessage: 'Search {service}' },
  useThis: { id: 'app.sml.servicesPanel.findIt.useThis', defaultMessage: 'Use this' },
  searching: { id: 'app.sml.servicesPanel.findIt.searching', defaultMessage: 'Searching {service}…' },
  from: { id: 'app.sml.servicesPanel.findIt.from', defaultMessage: 'From the {service} search.' },
  noMatchTitle: { id: 'app.sml.servicesPanel.findIt.noMatch.title', defaultMessage: 'No match on {service}' },
  noMatchBody: {
    id: 'app.sml.servicesPanel.findIt.noMatch.body',
    defaultMessage:
      'Try other words, for example only the title. A song can take a few days to show on a service after release.',
  },
  failedTitle: {
    id: 'app.sml.servicesPanel.findIt.failed.title',
    defaultMessage: 'The {service} search did not answer',
  },
  failedBody: {
    id: 'app.sml.servicesPanel.findIt.failed.body',
    defaultMessage: 'Nothing changed. Try again in a moment.',
  },
  tryAgain: { id: 'app.sml.servicesPanel.findIt.tryAgain', defaultMessage: 'Try again' },
  notSearchableTitle: {
    id: 'app.sml.servicesPanel.findIt.notSearchable.title',
    defaultMessage: 'MUSIC24 cannot search {service}',
  },
  notSearchableBody: {
    id: 'app.sml.servicesPanel.findIt.notSearchable.body',
    defaultMessage: 'Open {service}, find the song, copy its link and paste it here.',
  },
  pasteInstead: { id: 'app.sml.servicesPanel.findIt.pasteInstead', defaultMessage: 'Paste the link instead' },
  close: { id: 'app.sml.servicesPanel.findIt.close', defaultMessage: 'Close' },
});
